import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'

export const APP_BAR_HEIGHT = '48px'

export default function DataViewerAppBar() {
    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position='static' sx={{ backgroundColor: (theme) => theme.palette.primary.main }}>
                <Toolbar variant='dense'>
                    <Typography variant='h6' color='inherit' component='div'>
                        Log Viewer
                    </Typography>
                </Toolbar>
            </AppBar>
        </Box>
    )
}
